// import { getFeedUrl } from 'helpers/feeds/generalHelpers';
import reducerRegistry from 'reduxUtils/reducerRegistry';
import makeRequest from 'utils/makeRequest';
import { UNIFIED_FEED_DOMAIN } from 'constants/index';
// import { getMsidFromPath } from 'utils/common';

const reducerName = 'photostory';
const createActionName = name => `toi/${reducerName}/${name}`;

// actions
export const RECEIVE_DATA = createActionName('RECEIVE_DATA');
export const HANDLE_DATA_ERROR = createActionName('HANDLE_DATA_ERROR');
export const DATA_LOADING = createActionName('DATA_LOADING');
export const DATA_LOADED = createActionName('DATA_LOADED');

// action creators
function receivePhotostoryData(data, params) {
  return {
    type: RECEIVE_DATA,
    payload: {
      data,
      msid: params.photostoryMsid,
    },
  };
}

function handleArticleshowDataError(error) {
  return {
    type: HANDLE_DATA_ERROR,
    error,
  };
}

function dataLoading() {
  return {
    type: DATA_LOADING,
    payload: {},
  };
}

function dataLoaded() {
  return {
    type: DATA_LOADED,
    payload: {},
  };
}

//data gatherers
function fetchPhotostoryData(params, isAppView, dispatch) {
  dispatch(dataLoading());
  //   const appParameter = isAppView ? '&frmapp=yes' : '';
  //   const primeuser = params.frmprime === 'yes' ? '&isprime=true' : '';
  //   https://nprelease.indiatimes.com/wufs/show/photo?pc=toi&fv=2000&dm=p&id=106446641&isMobile=true&client=toi
  const isWapView = !!params.isWapView;
  const url = `${UNIFIED_FEED_DOMAIN}/wufs/feed/show/photo?pc=toi&dm=t&msid=${
    params.photostoryMsid
  }${isWapView ? '&isMobile=true' : ''}&client=toi&pp=20`;
  return makeRequest.get(url, { isMobile: isWapView });
}

export function loadPhotostoryData(params, isAppView) {
  return dispatch =>
    new Promise(resolve => {
      fetchPhotostoryData(params, isAppView, dispatch)
        .then(data => {
          dispatch(dataLoaded());
          dispatch(receivePhotostoryData(data.data, params));
          resolve('1'); // To check & return data load status
        })
        .catch(error => {
          dispatch(dataLoaded());
          dispatch(handleArticleshowDataError(error));
          resolve('0');
        });
    });
}

// reducer
export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case RECEIVE_DATA: {
      const articleShowData = state.data ? { ...state.data } : {};

      articleShowData[action.payload.msid] = action.payload.data;
      const articleData = articleShowData[action.payload.msid];
      articleData.seo = {};
      if (action.payload.data && action.payload.data.seolocation) {
        articleData.wu = `https://timesofindia.indiatimes.com/${
          action.payload.data.seolocation
        }/photostory/${action.payload.msid}.cms`;
        articleData.seo.canonical = `https://timesofindia.indiatimes.com/${
          action.payload.data.seolocation
        }/photostory/${articleData.id || action.payload.msid}.cms`;
      }
      if (action.payload.data && action.payload.data.secname) {
        articleData.hl = action.payload.data.secname;
        articleData.seo.title = action.payload.data.secname;
      }

      if (action.payload.data && action.payload.data.it) {
        const itData = action.payload.data.it;
        articleData.images = [
          {
            id: itData.id,
            imagesize: itData.imgsize,
            cap: itData.cap,
          },
        ];
      }

      articleShowData[action.payload.msid] = articleData;
      // console.log('test:', articleShowData);
      return {
        ...state,
        data: articleShowData,
      };
    }
    case DATA_LOADING: {
      return {
        ...state,
        dataLoading: true,
      };
    }
    case DATA_LOADED: {
      return {
        ...state,
        dataLoading: false,
      };
    }
    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
